const Page404 = () =>
    <section className="row my-5">
        <div className="col-6 offset-3 text-center">
            <img className="img-fluid my-5" src={require('../statics/images/under-construction.png')} alt="DataVault 404"></img>
        </div>
    </section>

export default Page404